import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const getSisenseToken = async (email) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GENERATE_SISENSE_TOKEN + "email=" + email,
    token
  );
  return res;
};
